module.exports = __webpack_public_path__ + "static/media/case-study-separator.2250666d.png";